<template>
  <div>
    <div class="goods-item">
      <div class="goods-img c-pointer" @click="toDetail(itemData)">
        <img v-lazy="itemData.image ? itemData.image : $defaultImg" alt="" />
        <div class="goods-icon" v-if="itemData.isForbidAreaSale">
          <img :src="require('@/assets/images/all_ddjs.png')" alt="" />
        </div>
        <div class="goods-icon" v-if="!itemData.isForbidAreaSale">
          <img
            :src="require('@/assets/images/all_yxj.png')"
            v-if="!itemData.status"
            alt=""
          />
          <img
            :src="require('@/assets/images/all_zwh.png')"
            v-if="
              itemData.status && itemData.stock < (num || itemData.quantity)
            "
            alt=""
          />
          <img
            :src="require('@/assets/images/all_xq.png')"
            v-if="
              itemData.status &&
              itemData.isExpiring &&
              itemData.stock >= (num || itemData.quantity)
            "
            alt=""
          />
        </div>
      </div>
      <div class="goods-info">
        <div class="goods-name c-pointer" @click="toDetail(itemData)">
          <span v-if="itemData.goodsActivityInfo"
            ><i v-if="itemData.goodsActivityInfo.activity">{{
              itemData.goodsActivityInfo.activityBadge
            }}</i></span
          >
          {{ itemData.name }}
        </div>
        <div class="goods-desc">
          <p v-if="itemData.type == 1">规格：{{ itemData.specification }}</p>
          <p v-if="itemData.type == 1">厂家：{{ itemData.manufacturer }}</p>
          <p class="expireDate" v-if="itemData.type == 1">
            效期：{{ itemData.expireDate }}
          </p>
          <p class="expireDate" v-if="itemData.isForbidAreaSale">
            此商品不支持在当前地区销售
          </p>
          <p class="p1" v-if="itemData.type == 2">套餐商品</p>
        </div>
      </div>
      <div class="goods-price" v-if="itemData.goodsActivityInfo">
        <p>￥{{ itemData.priceStr }}</p>
        <p
          class="hx"
          v-if="itemData.goodsActivityInfo.activity && itemData.type == 1"
        >
          ￥{{ itemData.goodsPriceStr }}
        </p>
      </div>
      <div class="goods-num">
        <input-number
          @eventClick="getNumber"
          :num="num || itemData.quantity"
          :maxNumber="
            itemData.stock > itemData.goodsActivityInfo.limitedCount
              ? itemData.goodsActivityInfo.limitedCount
              : itemData.stock
          "
          :skuNum="itemData.pack ? itemData.chineseMedicinePack : null"
          v-if="itemData.goodsActivityInfo.limited"
        ></input-number>
        <input-number
          @eventClick="getNumber"
          :num="num || itemData.quantity"
          :maxNumber="itemData.stock"
          :skuNum="itemData.pack ? itemData.chineseMedicinePack : null"
          v-else
        ></input-number>
      </div>
      <div class="goods-subtotal">
        <p>￥{{ subPrice }}</p>
      </div>
      <div class="goods-event">
        <span class="c-pointer" @click="del(itemData.cartItemId, index)"
          >删除</span
        >
      </div>
    </div>
    <div class="meal-container" v-if="itemData.type == 2">
      <div
        class="meal-item"
        v-for="(item, index) in itemData.goodses"
        :key="index"
      >
        <div class="meal-img c-pointer" @click="toGoodsDetail(item)">
          <img v-lazy="item.image ? item.image : $defaultImg" alt="" />
        </div>
        <div class="meal-info">
          <div class="meal-name c-pointer" @click="toGoodsDetail(item)">
            {{ item.name }}
          </div>
          <div class="meal-desc">
            <p>{{ item.manufacturer }}</p>
          </div>
        </div>
        <div class="meal-num">× {{ item.quantity }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import inputNumber from "@/components/input-number.vue";
export default {
  components: { inputNumber },
  data() {
    return {
      num: "",
      price: 10.4,
      subPrice: "",
      type: 2, //1单品，2套餐
      editType: "update",
    };
  },
  props: {
    index: {
      type: Number,
      defalut: "",
    },
    checked: {
      type: Boolean || String,
      defalut: false,
    },
    itemData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {
    checked: {
      handler: function (t, f) {
        this.$parent.total({
          index: this.index,
          num: this.num || this.itemData.quantity,
          subPrice:
            this.subPrice || this.getSub(this.num || this.itemData.quantity),
          couponAmount:
            this.itemData.quantity *
            (this.itemData.goodsPrice - this.itemData.price),
          checked: t || false,
          cartItemId: this.itemData.cartItemId,
          disable:
            this.itemData.isForbidAreaSale ||
            this.itemData.stock < (this.num || this.itemData.quantity) ||
            this.itemData.status == false ||
            this.islimited(
              this.num || this.itemData.quantity,
              this.itemData.goodsActivityInfo.limited,
              this.itemData.goodsActivityInfo.limitedCount
            ),
        });
      },
      immediate: true,
    },
    "itemData.price": function (t, f) {
      this.$parent.total({
        index: this.index,
        num: this.num || this.itemData.quantity,
        subPrice: this.getSub(this.num || this.itemData.quantity),
        couponAmount:
          this.itemData.quantity *
          (this.itemData.goodsPrice - this.itemData.price),
        checked: this.checked,
        cartItemId: this.itemData.cartItemId,
        disable:
          this.itemData.isForbidAreaSale ||
          this.itemData.stock < (this.num || this.itemData.quantity) ||
          this.itemData.status == false ||
          this.islimited(
            this.num || this.itemData.quantity,
            this.itemData.goodsActivityInfo.limited,
            this.itemData.goodsActivityInfo.limitedCount
          ),
      });
    },
  },
  methods: {
    islimited(num, limited, limitedCount) {
      if (limited) {
        return limitedCount < num;
      } else {
        return false;
      }
    },
    getNumber(data) {
      this.num = data;
      this.getSub(data);
      this.editCart(this.itemData.cartItemId);
      this.$parent.total({
        index: this.index,
        num: data || this.itemData.quantity,
        subPrice:
          this.subPrice || this.getSub(this.num || this.itemData.quantity),
        couponAmount:
          this.itemData.quantity *
          (this.itemData.goodsPrice - this.itemData.price),
        checked: this.checked || false,
        cartItemId: this.itemData.cartItemId,
        disable:
          this.itemData.isForbidAreaSale ||
          this.itemData.stock < (this.num || this.itemData.quantity) ||
          this.itemData.status == false ||
          this.islimited(
            this.num || this.itemData.quantity,
            this.itemData.goodsActivityInfo.limited,
            this.itemData.goodsActivityInfo.limitedCount
          ),
      });
    },
    getSub(num) {
      this.subPrice = (this.itemData.priceStr * num).toFixed(2);
      return this.subPrice;
    },
    del(cartItemId, index) {
      this.$emit("del", { cartItemId, index });
    },
    editCart(id) {
      var type = this.editType;

      this.$api
        .POST_EDITCART({
          cartItemId: id,
          type: this.editType,
          quantity: this.num,
        })
        .then((res) => {
          if (res.status) {
            this.itemData.stock >= this.num
              ? (this.itemData.isOutofstok = false)
              : (this.itemData.isOutofstok = true);
            this.$emit("updateCartList");
          }
        });
    },
    toDetail(item) {
      let goodsId;
      item.type == 1
        ? (goodsId = item.goodsId)
        : (goodsId = item.combinationId);
      this.$router.push({
        name: "detail",
        query: { type: item.type, goodsId },
      });
    },
    toGoodsDetail(item) {
      this.$router.push({
        name: "detail",
        query: { type: 1, goodsId: item.goodsId },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-item {
  font-size: 14px;
  height: 140px;
  align-items: center;
  display: flex;
  .goods-img {
    position: relative;
    margin-right: 28px;
    width: 116px;
    height: 118px;
    border: 1px solid #f2f2f2;
    img {
      @include size(100%, 100%);
    }
    .goods-icon {
      position: absolute;
      bottom: 0;
      right: 0;
      @include flex-c;
      @include size(100%, 100%);

      img {
        @include size(80%, 80%);
      }
    }
  }
  .goods-info {
    width: 290px;
    height: 100%;
    margin-right: 110px;
    .goods-name {
      margin-top: 24px;
      color: #505050;
      margin-bottom: 28px;
      line-height: 20px;
      // @include textLineClamp(1);
      i {
        display: inline-block;
        //  width: 40px;
        padding: 0 6px;
        height: 20px;
        border: 1px solid #fa4b4b;
        @include font(12px, #fa4b4b, center, 400, 19px);
        margin-right: 5px;
        border-radius: 3px;
      }
    }
    .goods-desc {
      color: #999999;
      font-size: 12px;
      line-height: 16px;
      p {
        @include textLineClamp(1);
      }
      .p1 {
        padding-top: 20px;
      }
    }
  }
  .goods-price {
    width: 90px;
    text-align: center;
    margin-right: 85px;
    p {
      color: #222222;
      font-weight: 600;
    }
    .hx {
      font-weight: 100;
      color: #999999;
      font-size: 13px;
      margin-top: 8px;
    }
  }
  .goods-num {
    width: 112px;
    margin-right: 10px;
  }
  .goods-subtotal {
    width: 150px;
    text-align: center;
    color: #fa4b4b;
    font-weight: 600;
    margin-right: 10px;
  }
  .goods-event {
    width: 90px;
    color: #666666;
    text-align: center;
  }
}
.meal-container {
  padding-right: 56px;
  flex-wrap: wrap;
  display: flex;
  .meal-item {
    background: #fafafa;
    position: relative;
    height: 114px;
    align-items: center;
    display: flex;
    padding: 28px 0 20px 40px;
    width: 1064px;
    &:nth-child(n-1) {
      border-bottom: 1px solid #eeeeee;
    }
    .meal-img {
      margin-right: 16px;
      border: 1px solid #f2f2f2;
      img {
        width: 64px;
        height: 64px;
      }
    }
    .meal-info {
      height: 100%;
      .meal-name {
        margin-top: 8px;
        margin-bottom: 24px;
        font-size: 14px;
        color: #505050;
      }
      .meal-desc {
        color: #999999;
        font-size: 12px;
      }
    }
    .meal-num {
      position: absolute;
      right: 40px;
      font-size: 16px;
      color: #505050;
      font-weight: 600;
    }
  }
}
.expireDate {
  color: #fa4b4b;
  margin-top: 5px;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/pages/cart/components/cart-goods-item.vue